import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
};

const exportTemplateTimeKeepingSlice = createSlice({
  name: "exportTemplateTimeKeeping",
  initialState,
  reducers: {
    exportTemplateTimeKeepingStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    exportTemplateTimeKeepingSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    exportTemplateTimeKeepingFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  exportTemplateTimeKeepingStart,
  exportTemplateTimeKeepingSuccess,
  exportTemplateTimeKeepingFailed,
} = exportTemplateTimeKeepingSlice.actions;

export default exportTemplateTimeKeepingSlice.reducer;
